var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"disabled":_vm.disabled,"color":_vm.selected ? 'secondary' : '',"elevation":_vm.selected ? 2 : 0,"block":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }